import { Component, createRef } from 'react';
import { INSBox } from './INSBox';
import { NSBoxSchemaVariable } from './NSBoxSchemaVariable';
import { BaseVariableSchema } from 'namirasoft-schema';
import { NSRepeater } from './NSRepeater';
import { IBaseComponentProps } from '../props/IBaseComponentProps';
import { INSBoxBaseLayoutProps } from './NSBoxBaseLayout';

export interface NSRepeaterNSBoxSchemaVariableProps extends IBaseComponentProps, INSBoxBaseLayoutProps<NSBoxSchemaVariable, BaseVariableSchema>
{
	name: string;
	onItemChanged?: (repeater: NSRepeaterNSBoxSchemaVariable) => void;
	onValuesChanged?: (repeater: NSRepeaterNSBoxSchemaVariable) => void;
	required: boolean;
	min?: number;
	max?: number;
	item_title: string;
	item?: IBaseComponentProps;
}

export class NSRepeaterNSBoxSchemaVariable extends Component<NSRepeaterNSBoxSchemaVariableProps> implements INSBox
{
	private Repeater_Refs = createRef<NSRepeater<NSBoxSchemaVariable, BaseVariableSchema>>();
	constructor(props: NSRepeaterNSBoxSchemaVariableProps)
	{
		super(props);
		this.isEmpty = this.isEmpty.bind(this);
		this.getError = this.getError.bind(this);
		this.getValue = this.getValue.bind(this);
		this.setValue = this.setValue.bind(this);
	}
	isEmpty(): boolean
	{
		return this.Repeater_Refs.current?.isEmpty() ?? true;
	}
	getError(): string | null
	{
		return this.Repeater_Refs.current?.getError() ?? null;
	}
	getValue(checkError: boolean = true): BaseVariableSchema[] 
	{
		return (this.Repeater_Refs.current?.getValue(checkError) ?? []).filter(x => x) as BaseVariableSchema[];
	}
	setValue(value: BaseVariableSchema[], callback?: () => void): void
	{
		this.Repeater_Refs.current?.setValue(value, callback);
	}
	override render()
	{
		return <NSRepeater<NSBoxSchemaVariable, BaseVariableSchema>
			ref={this.Repeater_Refs}
			{...this.props}
			ignoreItemsHavingError
			createItem={(gIndex: number, lIndex: number, ref: React.RefObject<NSBoxSchemaVariable>, onChange: () => void, onDelete: undefined | ((lIndex: number) => void)) =>
			{
				return <NSBoxSchemaVariable
					id={this.props.item?.id}
					classList={this.props.item?.classList}
					style={this.props.item?.style}
					ref={ref}
					key={`NSRepeaterNSBoxSchemaVariable_${this.props.name}_item_${gIndex}`}
					name={`${this.props.name}_${gIndex}`}
					required
					title={`${this.props.item_title} ${(lIndex + 1)}`}
					menu={{ builtin: { delete: { enabled: true, onDelete: () => { onDelete?.(lIndex) } } }, items: [] }}
					onChanged={onChange}
				/>
			}}
			setValue={(item: NSBoxSchemaVariable, _: number, value: BaseVariableSchema | null) =>
			{
				item.setValue(value);
			}}
			getValue={(item: NSBoxSchemaVariable, checkError: boolean) =>
			{
				return item.getValue(checkError);
			}}
			isEmpty={(item: NSBoxSchemaVariable, value: BaseVariableSchema | null) =>
			{
				return item.isEmpty(value);
			}}
			onItemChanged={() =>
			{
				this.props.onItemChanged?.(this);
			}}
			onValuesChanged={() =>
			{
				this.props.onValuesChanged?.(this);
			}}
		/>;
	}
}